import { useState } from "react";
import { DyteSpinner } from "@dytesdk/react-ui-kit";
import { useSearchParams } from "react-router-dom";

import { useMeeting } from "../../../../hooks/useMeeting";
import { useLiveMeetingAnalysis } from "../../../../hooks/useMeetingAnalysis";
import { resourcesAvailable } from "../../data/resources";
import ConvDynamics from "./components/ConvDynamics";
import { MeetingSummary } from "./components/MeetingSummary";
import { ResourcesShared } from "./components/ResourcesShared";
import { RiskMonitor } from "./components/RiskMonitor";

export function PostSession() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("sessionId");

  const { data: meeting } = useMeeting(sessionId!);
  const { data: meetingAnalysis } = useLiveMeetingAnalysis(sessionId!);
  console.log("MEETING: ", meeting);

  const [convDynamics, setConvDynamics] = useState<any>(null);

  const calculateConvDynamics = (data: any) => {
    const totalTalkTime =
      data.result["speaker_stats"]["MENTOR"]["time_spent"] +
      data.result["speaker_stats"]["MENTEE"]["time_spent"];
    const talkTimeRatioMentor = (
      data.result["speaker_stats"]["MENTOR"]["time_spent"] / totalTalkTime
    ).toFixed(2);
    const talkTimeRatioMentee = (
      data.result["speaker_stats"]["MENTEE"]["time_spent"] / totalTalkTime
    ).toFixed(2);

    setConvDynamics({
      talkTimeRatioMentor: talkTimeRatioMentor,
      talkTimeRatioMentee: talkTimeRatioMentee,
      wordCountMentor: data.result["speaker_stats"]["MENTOR"]["word_count"],
      wordCountMentee: data.result["speaker_stats"]["MENTEE"]["word_count"],
    });
  };

  const resourcesSharedDummy = resourcesAvailable;

  const mentorSkillsDummy = {
    techniquesUsed: ["active listening", "open-ended questions", "reflection"],
    growthAreas: [
      "increase open-ended questions",
      "allow more reflection time",
    ],
  };

  const convDynamicsDummy = {
    talkTimeRatioMentor: 0.5,
    talkTimeRatioMentee: 0.5,
    wordCountMentor: 100,
    wordCountMentee: 100,
  };

  if (!meeting || !meetingAnalysis) {
    return (
      <div className="h-full flex flex-col justify-center items-center">
        <DyteSpinner />
        <p className="text-gray-500">Loading analysis...</p>
      </div>
    );
  }

  return (
    <div className="main-content bg-white max-w-7xl mx-auto rounded-lg shadow-lg p-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <MeetingSummary meeting={meeting} analysis={meetingAnalysis} />
        <ConvDynamics {...(convDynamics || convDynamicsDummy)} />
        <RiskMonitor analysis={meetingAnalysis} />
        <ResourcesShared resources={resourcesSharedDummy} />
      </div>
    </div>
  );
}
